import { Separator } from "@components/ui/separator"
import { SidebarTrigger } from "@components/ui/sidebar"
import { HeaderSearch } from "./HeaderSearch"
import { UserMenu } from "./UserMenu"

export const AppHeader = () => (
  <header className="tw:sticky tw:top-0 tw:z-10 tw:flex tw:h-16 tw:shrink-0 tw:items-center tw:gap-2 tw:border-b tw:border-border tw:bg-neutral-50 tw:px-4">
    <SidebarTrigger className="tw:-ml-1" />
    <Separator
      orientation="vertical"
      className="tw:mr-2 tw:data-[orientation=vertical]:h-4"
    />
    <HeaderSearch />
    <UserMenu />
  </header>
)
